import { request } from './http';

export async function getComplianceMapData() {
    return request('/compliance/map');
  }

export async function getComplianceRecords(filters = {}) {
    return request('/compliance/filter', {
      method: 'POST',
      body: JSON.stringify(filters),
    });
  }

export async function getFacilityRecords(listKey, filters = {}) {
    return request(`/facility-records/${encodeURIComponent(listKey)}/filter`, {
      method: 'POST',
      body: JSON.stringify(filters),
    });
  }

export async function getSpccRoutineRecords(filters = {}) {
    return request('/spcc-routine/filter', {
      method: 'POST',
      body: JSON.stringify(filters),
    });
  }

export async function getComplianceRecordById(id) {
    return request(`/compliance/${id}`);
  }

export async function getComplianceRecordChangeHistory(id) {
    return request(`/compliance/${id}/change-history`);
  }

export async function getComplianceFormData() {
    return request('/compliance/form-data');
  }

export async function createComplianceRecord(recordData) {
    return request('/compliance', {
      method: 'POST',
      body: JSON.stringify(recordData),
    });
  }

export async function updateComplianceRecord(id, recordData) {
    return request(`/compliance/${id}`, {
      method: 'PUT',
      body: JSON.stringify(recordData),
    });
  }

export const complianceMapApi = {
  getComplianceMapData,
  getComplianceRecords,
  getFacilityRecords,
  getSpccRoutineRecords,
  getComplianceRecordById,
  getComplianceRecordChangeHistory,
  getComplianceFormData,
  createComplianceRecord,
  updateComplianceRecord,
};

